import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { Tournament } from '../tournament.model';

@JsonObject('TournamentsResultsResponse')
export class TournamentsResultsResponse extends ApiResultsResponse<Tournament> {

  @JsonProperty('results', [Tournament])
  override results: Tournament[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
